const SEPARATOR = ';'
const BOM = '\uFEFF'

export function escapeCsvValue(value) {
  const text = value === null || value === undefined ? '' : String(value)
  return /[;"\r\n]/.test(text) ? `"${text.replace(/"/g, '""')}"` : text
}

export function buildCsv(lines) {
  return lines
    .map(line => line.map(escapeCsvValue).join(SEPARATOR))
    .join('\r\n')
}

export function buildCsvBlob(lines) {
  return new Blob([`${BOM}${buildCsv(lines)}`], { type: 'text/csv;charset=utf-8;' })
}
